<template>
  <div class="navbar">
    <div class="site-title">
      <h3>HPU</h3>
    </div>
    <ul class="user-account">
      <li>
        <a
          ><img src="@/assets/no-image.png" alt="Profile" class="avatar" />
          {{ user ? user.fullname : "" }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "layout-navbar",
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>
